// Dados do controlador usados nas páginas legais (cadastro na Receita Federal, CNPJ 35.147.426/0001-57).
export const LEGAL = {
  brand: 'Seu Impulso',
  company: 'DifLabs Tecnologia Ltda.',
  cnpj: 'CNPJ 35.147.426/0001-57',
  privacyEmail: 'privacidade@seuimpulso.com.br',
  supportEmail: 'suporte@seuimpulso.com.br',
  dpoName: 'Cayo Henrique Serra Rodrigues (encarregado de dados)',
  updatedAt: '16/10/2026',
}
